// useIsPWA.ts
import { useEffect, useState } from "react";

function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;

  // iOS (A2HS)
  // @ts-ignore
  if (typeof navigator !== "undefined" && navigator.standalone) return true;

  // Wspólne: Android, Desktop (Chrome/Edge), macOS Safari Web App
  const modes = ["standalone", "fullscreen", "minimal-ui"];
  return modes.some((m) => window.matchMedia?.(`(display-mode: ${m})`).matches);
}

export function useIsPWA() {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    setIsPWA(isStandaloneDisplayMode());

    // nasłuchuj zmian display-mode (np. otwarcie okna z notyfikacji)
    const mqls =
      typeof window !== "undefined"
        ? ["standalone", "fullscreen", "minimal-ui"]
            .map((m) => window.matchMedia?.(`(display-mode: ${m})`))
            .filter(Boolean) as MediaQueryList[]
        : [];

    const onChange = () => setIsPWA(isStandaloneDisplayMode());
    mqls.forEach((mql) => mql.addEventListener?.("change", onChange));

    // iOS nie wspiera powyższego – jako “best effort” odświeżamy przy visibilitychange
    const vis = () => setIsPWA(isStandaloneDisplayMode());
    document.addEventListener("visibilitychange", vis);

    return () => {
      mqls.forEach((mql) => mql.removeEventListener?.("change", onChange));
      document.removeEventListener("visibilitychange", vis);
    };
  }, []);

  // SSR safety: do czasu montażu zwracamy false, żeby nie było FOUC
  return isPWA;
}
